import { UseFormTrigger, FieldValues, Path } from "react-hook-form";

/**
 * Force immediate validation trigger for a form field
 * This helps ensure form validation state is updated immediately
 *
 * Uses double setTimeout to ensure both React state and React Hook Form state are synced:
 * 1. First setTimeout: waits for React state updates to be flushed
 * 2. Second setTimeout: waits for useEffect (setValue) to be executed
 * 3. Finally triggers validation with the correct state
 */
export const forceValidation = <T extends FieldValues>({
  trigger,
  name,
}: {
  trigger?: UseFormTrigger<T>;
  name: Path<T>;
}): void => {
  if (!trigger) return;

  setTimeout(async () => {
    // Wait one more tick to ensure setValue() in useEffect has been executed
    await new Promise((resolve) => setTimeout(resolve));
    await trigger(name);
  });
};
